export default __webpack_public_path__ + "static/media/pickup_drivethru.242298c8.svg";